import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d558m8sg267ndt4abuh0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/256782322561', '_blank');
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-[#F0F9FF] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B4F6C] mb-4">Get in Touch</h2>
          <div className="w-20 h-1 bg-[#14B8A6] mx-auto mb-4"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Ready to start your journey to recovery? Contact us today to schedule your consultation
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <button
            onClick={handleWhatsApp}
            className="flex items-center justify-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#20BA5A] transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Chat with Dr. Sadat on WhatsApp
          </button>
          <button
            onClick={scrollToTop}
            className="flex items-center justify-center gap-3 bg-[#14B8A6] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#0D9488] transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line text-2xl"></i>
            Book Consultation
          </button>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0B4F6C] mb-2">Phone Numbers</h3>
                  <a
                    href="tel:+256782322561"
                    className="block text-sm text-gray-600 hover:text-[#14B8A6] transition-colors mb-1"
                  >
                    +256 782 322 561
                  </a>
                  <a
                    href="tel:+256758903109"
                    className="block text-sm text-gray-600 hover:text-[#14B8A6] transition-colors"
                  >
                    +256 758 903 109
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0B4F6C] mb-2">Email Addresses</h3>
                  <a
                    href="mailto:carejoint8@gmail.com"
                    className="block text-sm text-gray-600 hover:text-[#14B8A6] transition-colors mb-1"
                  >
                    carejoint8@gmail.com
                  </a>
                  <a
                    href="mailto:info@carejointphysioclinic.co.za"
                    className="block text-sm text-gray-600 hover:text-[#14B8A6] transition-colors"
                  >
                    info@carejointphysioclinic.co.za
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0B4F6C] mb-2">Our Location</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Nsambya Estate, Opposite Joint Medical Stores
                    <br />
                    Kampala, Uganda
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-md">
              <div className="w-full h-64">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7573!2d32.5825!3d0.2975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMMKwMTcnNTEuMCJOIDMywrAzNCc1Ny4wIkU!5e0!3m2!1sen!2s!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="CareJoint Physiotherapy Clinic Location"
                ></iframe>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-md">
            <h3 className="text-2xl font-bold text-[#0B4F6C] mb-6">Send Us a Message</h3>
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent outline-none transition-all"
                  placeholder="Enter your full name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent outline-none transition-all"
                  placeholder="your.email@example.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent outline-none transition-all"
                  placeholder="+256 XXX XXX XXX"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent outline-none transition-all resize-none"
                  placeholder="Tell us about your condition or inquiry..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-checkbox-circle-line mr-2"></i>
                  Thank you! Your message has been sent successfully. We'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  Sorry, there was an error sending your message. Please try again or contact us directly.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#14B8A6] text-white py-3 rounded-lg text-base font-semibold hover:bg-[#0D9488] transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center">
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Sending...
                  </span>
                ) : (
                  'Send Message'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}